import { getField } from 'vuex-map-fields';

export default {
  addContact: state => state.addContact,
  deleteContact: state => state.deleteContact,
  ctrlPanelDisplayedGet: state => state.ctrlPanelDisplayed,
  activeSection: state => state.activeSection,
  contactData: state => state.contactData,
  contactDataIsLoading: state => state.contactDataIsLoading,
  notes: state => state.notes,
  loadingNotes: state => state.loadingNotes,
  notesViewActiveForContact: state => state.notesViewActiveForContact,
  activeDetailsSection: state => state.activeDetailsSection,
  getField,
};
